import { useLocalObservable } from 'mobx-react-lite';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { GrispiEvents } from '../EventAndActionNames';
import { grispiNotification } from '../store/useNotificationStore';
import getStore from '../utils/store/getStore';
import useAgentStatus from './agentStatus/useAgentStatus';

export interface useCallPluginReturnValue {
    startACallForExistingTicket: (phoneNumber: string, ticketKey: string) => void;
}

export default function useCallPlugin(): useCallPluginReturnValue {
    const { callPlugin } = useLocalObservable(() => getStore().PluginStore);
    const { data: currentStatus, isLoading: isLoadingCurrentStatus } = useAgentStatus();
    const { t } = useTranslation('forms');
    const { t: tStatus } = useTranslation('agentStatus');

    const pluginId = callPlugin?.pluginId;

    const startACallForExistingTicket = useCallback(
        (phoneNumber, ticketKey): void => {
            let errorMessage = null;
            if (!ticketKey) {
                errorMessage = t('internal error');
            } else if (!phoneNumber || phoneNumber === 'null') {
                errorMessage = t('phone number not present');
            } else if (isLoadingCurrentStatus || !currentStatus) {
                errorMessage = t('agent status not ready');
            } else if (currentStatus?.status.call !== 'ONLINE' && currentStatus?.status.call !== 'ONLINE_OUTBOUND') {
                errorMessage = t('agent status not valid for call action');
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                errorMessage = errorMessage.replace('${STATUS}', tStatus(currentStatus.status.i18n));
            }

            if (errorMessage) {
                grispiNotification('error', errorMessage, 'error');
                return;
            }
            // FIXME when we refactor RequesterInfoContainer and don't call startACallForExistingTicket directly from there
            //we can remove above logic which is already present in CallNowActionButton component.

            {
                // Make the call
                const event = new CustomEvent(GrispiEvents.MESSAGE_TO_PLUGIN, {
                    detail: {
                        pluginId,
                        data: { type: 'grispi.call.request.makeCall', phoneNumber, ticketKey }
                    }
                });
                window.dispatchEvent(event);
            }

            {
                // Show the call plugin popup
                const event = new CustomEvent(GrispiEvents.SHOW_PLUGIN_EVENT, {
                    detail: {
                        pluginId
                    }
                });
                window.dispatchEvent(event);
            }

            grispiNotification('info', t('callRequestSent', { phoneNumber }), 'info');
            return;
        },
        [isLoadingCurrentStatus, currentStatus, t, tStatus, pluginId]
    );

    return { startACallForExistingTicket };
}
